var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bg-gray-200 min-h-screen app_page"},[_c('div',[_c('div',{staticClass:"app_top_image",style:({ backgroundImage: `url(${_vm.background})` })})]),_c('div',{staticClass:"container mx-auto main-content"},[_c('div',{staticClass:"px-3 sm:px-4 py-2 sm:py-4"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }